// « Under the hood » : les six mécanismes en grille 3 × 2, chacun dans une
// carte bleu profond où l'icône 3D en verre (public/media/icons/<clé>.webp,
// fond transparent) s'allume d'un halo — le rendu de la planche générée.
import { useT } from '../../lib/i18n'

const PUB = process.env.PUBLIC_URL || ''

export default function Inside () {
  const s = useT().inside
  return (
    <section className="lp-sec" id="inside">
      <div className="lp-wrap">
        <div className="lp-head lp-head--center lp-rv">
          <span className="lp-kicker">{s.kicker}</span>
          <h2 className="lp-h2">{s.title}</h2>
          <p className="lp-lead">{s.lead}</p>
        </div>

        <ul className="lp-glow">
          {s.items.map(it => (
            <li key={it.k} className="lp-glow__c lp-rv">
              <span className="lp-glow__ic" aria-hidden="true">
                <img src={`${PUB}/media/icons/${it.k}.webp`} alt="" width="200" height="200" loading="lazy" />
              </span>
              <b>{it.t}</b>
              <span>{it.p}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
